import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const abuseipdb = defineConnector({
  identifier: "abuseipdb",
  name: "AbuseIPDB",
  tagLine: "IP abuse reporting database",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.abuseipdb\\.com/.*",
  auth: (app) =>
    headerAuth([
      { name: "Key", value: app.secret.apiKey },
      { name: "Accept", value: "application/json" },
    ]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [AbuseIPDB](https://www.abuseipdb.com/) and create an account. Navigate to your account settings and click on the API tab to find your API key.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "AbuseIPDB API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.abuseipdb.com/api/v2/check?ipAddress=8.8.8.8",
  },
});
